<template>
  <div class="element-tab-item" :class="{ on }" @click="$emit( 'click' )">
    <slot />
  </div>
</template>
<script>
export default {
  props: [ "on" ]

}
</script>
